import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import {
  AiAgentAnalyticsFilters,
  AiAgentAnalyticsFiltersProvider,
} from 'src/components/pages/ai-agents/analytics/components/ai-agent-analytics-filters';

const StyledAiAgentAnalyticsFilters = styled(AiAgentAnalyticsFilters)`
  ${up('md')} {
    background: ${({ theme }) => theme.colors.porcelain};
    margin-bottom: 0;
    padding: 20px;
  }
`;

const EmptySection = styled.div`
  color: ${({ theme }) => theme.colors.flint};
  padding: 20px;
`;

export const AiAgentAnalyticsSection = memo<{ aiAgentId: string }>(({ aiAgentId }) => {
  const { t } = useTranslation(['aiAgents']);

  return (
    <AiAgentAnalyticsFiltersProvider aiAgentId={aiAgentId}>
      <StyledAiAgentAnalyticsFilters />
      <EmptySection data-lgg-id="ai-agent-analytics-section">
        {t('aiAgents:pages.agentDetails.emptySection')}
      </EmptySection>
    </AiAgentAnalyticsFiltersProvider>
  );
});
